<!-- Phone top bar: ☰ menu on the left, "Hideo" in the middle (Home), profile on the right with the online-save dot (and,
     only with an app theme other than Default, the speaker button next to it).
     The ids are used by the guided tour (tour.js). -->
<script setup lang="ts">
import { computed } from 'vue'
import HideoLogo from './HideoLogo.vue'
import ProfileAvatar from './ProfileAvatar.vue'
import SoundButton from './SoundButton.vue'
import { useThemeStore } from '../stores/theme'
import { useUiStore } from '../stores/ui'
import { usePage } from '../composables/usePage'
import { useI18n } from '../composables/useI18n'
import { useCloudStore } from '../stores/cloud'

const ui = useUiStore()
const { goTo } = usePage()
const { t } = useI18n()
const theme = useThemeStore()
const profileTitle = computed(() => t('Profile, projects and saving') + (ui.sync ? ' · ' + ui.sync.tip : ''))
const home = () => { ui.closeMobileMenu(); goTo('home') }
const profiles = () => useCloudStore().openProfiles()   // closes the ☰ menu too
</script>

<template>
  <div id="mobileBar" class="md:hidden glass-bar fixed top-0 inset-x-0 z-40 h-14 px-3 flex items-center justify-between border-b border-gray-800">
    <button id="mobileMenuBtn" type="button" :aria-label="t('Menu')" :aria-expanded="ui.mobileMenuOpen"
      class="w-10 h-10 rounded-full bg-darkcard border border-gray-800 text-gray-200 flex items-center justify-center" @click="ui.toggleMobileMenu()">
      <i :class="['fas', ui.mobileMenuOpen ? 'fa-xmark' : 'fa-bars']"></i>
    </button>
    <button type="button" class="absolute left-1/2 -translate-x-1/2 flex items-center gap-2 font-black tracking-wider text-gray-100" @click="home">
      <HideoLogo class="w-7 h-7" />HIDEO
    </button>
    <div class="flex items-center gap-2">
    <!-- Sounds of the app themes: only while a theme other than Default is on (a tap opens its panel) -->
    <SoundButton v-if="theme.style !== 'default'" btn-class="w-10 h-10 rounded-full bg-darkcard border border-gray-800 flex items-center justify-center" icon-class="text-sm" />
    <button id="mobileProfileBtn" type="button" :title="profileTitle" class="relative w-10 h-10 rounded-full bg-darkcard border border-gray-800 flex items-center justify-center" @click="profiles">
      <ProfileAvatar class="w-8 h-8 text-xs" />
      <span v-if="ui.sync" id="syncDot" class="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full bg-darkbg flex items-center justify-center text-[10px]">
        <i :class="['fas', ui.sync.icon, ui.sync.cls]"></i>
      </span>
    </button>
    </div>
  </div>
</template>
